

import React, { useEffect, useRef, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  ChevronUp,
  Download,
  File,
  Filter,
  PlusCircle,
  RotateCcw,
  Sliders,
  StopCircle,
  Archive,
  User,
  Calendar,
} from "feather-icons-react/build/IconComponents";
import Select from "react-select";
import { Table } from "antd";


import * as XLSX from "xlsx";
import { Checkbox } from "antd";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { DatePicker } from "antd";
// import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";





import { data } from "jquery";
import { paymentcard } from "../../components/constants/Constants";
import LoadingUtils from "../../core/utils/LoadingUtils";
import { exportreportExcel, exportreportPDF, printreportReport } from "../../core/utils/MainReportUtils";
import { fetchUser } from "../../redux/userServices";
import { fetchCounter, fetchCustomer, fetchSection, fetchSettings } from "../../redux/userSetting";
import { fetchCompanyDetail } from "../../redux/companyDetail";
import { renderTooltip } from "../../redux/helper";
import { getCustomerCreditReport, getSalesReport } from "../../services/ReportApiService";
import { DatatablePagingParameter, Filterclass } from "../../core/json/DatatablePagingParameters";
import { useDispatch, useSelector } from "react-redux";
import { setheadertoggle } from "../../redux/toggle";
import ImageWithBasePath from "../../core/img/imagewithbasebath";

const CustomerCredit = () => {
  const [searchText, setSearchText] = useState("");
   const [salesData, setsalesData] = useState();
   const [allData, setallData] = useState();
const [customer, setCustomer] = useState();
   const [loading, setloading] = useState(false);
   const [fromDate, setFromDate] = useState(dayjs());
   const [toDate, setToDate] = useState(dayjs());
   const [totalcount, settotalcount] = useState();
      const [decimalpoints, setDecimalPoints] = useState(2);
   const [currentPage, setCurrentPage] = useState(1);
   const [pageSize, setPageSize] = useState(20);
   const [special, setSpecial] = useState();
   const dispatch = useDispatch();
   const { branch } = useSelector((state) => state.branchlist);
   const { companyInfolist } = useSelector((state) => state.companyInfo);
   const { togglehead } = useSelector((state) => state.headerToggle);
   const { counterList, sectionList,settingList } = useSelector(
     (state) => state.usersetting
   );
  const {
   
    customerList,
  
    formatedcustomerList,
  } = useSelector((state) => state.usersetting);
   console.log(customerList,"customerList");
   console.log(formatedcustomerList,"formatedcustomerList");
   const tableRef = useRef(null);
 console.log(companyInfolist,"companyDetails");
 
   // const filteredData = salesData?.filter((entry) => {
   //   return Object.keys(entry).some((key) => {
   //     return String(entry[key])
   //       .toLowerCase()
   //       .includes(searchText.toLowerCase());
   //   });
   // });
   useEffect(() => {
     handlegetsalesReport(currentPage, pageSize);
     handlegetsalesfullReport();
     dispatch(fetchCompanyDetail());
     dispatch(fetchSection(branch.guid));
     dispatch(fetchUser());
     dispatch(fetchSettings(branch));
  dispatch(fetchCustomer(branch));
 
     const match = settingList?.currencyFormat?.toString()?.match(/\.0+/);
     const currfmt = match ? match[0]?.length - 1 : 0;
     setDecimalPoints(currfmt);

   }, [branch, fromDate, toDate]);
   
 
 
   const handlegetsalesReport = async (page, size) => {
     const DatatablePagingParameters = new DatatablePagingParameter();
     DatatablePagingParameters.PageNumber = page;
     DatatablePagingParameters.PageSize = size;
     const formattedfromDate = dayjs(fromDate).format("YYYY-MM-DD");
     const formattedtoDate = dayjs(toDate).format("YYYY-MM-DD");
     const Filters = new Filterclass();
     Filters.Branch = branch;
     Filters.FromDate = formattedfromDate;
     Filters.ToDate = formattedtoDate;
 Filters.Customer = customer?.value;
     try {
       const response = await getCustomerCreditReport({
         DatatablePagingParameters,
         Filters,
       });
 
  setsalesData(response?.data?.customerCreditReportDetail);

      settotalcount(response?.data?.customerCreditReportDetail[0]?.recordsFilteredCount);
     } catch (error) {
       console.error(
         "Error Fetching Account Type!",
         error?.response?.data?.Message
       );
     }
   };
   const handlegetsalesfullReport = async () => {
     setloading(true);
     const DatatablePagingParameters = new DatatablePagingParameter();
     DatatablePagingParameters.PageNumber = 1;
     DatatablePagingParameters.PageSize = -1;
     const formattedfromDate = dayjs(fromDate).format("YYYY-MM-DD");
     const formattedtoDate = dayjs(toDate).format("YYYY-MM-DD");
     const Filters = new Filterclass();
     Filters.Branch = branch;
     Filters.FromDate = formattedfromDate;
     Filters.ToDate = formattedtoDate;
     Filters.Customer = customer?.value;
     // Filters.PaymentType = paymenttype?.value;
     // Filters.Waiter = waiter?.value;
     // Filters.Counter = counterval?.value;
     // Filters.Section = sectionval?.value;
     try {
       const response = await getCustomerCreditReport({
         DatatablePagingParameters,
         Filters,
       });
setallData(response?.data?.customerCreditReportDetail);
       setloading(false);
     } catch (error) {
       console.error(
         "Error Fetching Account Type!",
         error?.response?.data?.Message
       );
       setloading(false);
     }
   };
   const handleSearch = (e) => {
     setSearchText(e.target.value);
   };

   const printTable = () => {
     window.print();
   };
 
 
const columns = [
  {
    title: "Date",
    dataIndex: "date",
    render: (text) =>
      text ? new Date(text).toLocaleDateString("en-GB") : "",
  },
  {
    title: "Bill No",
    dataIndex: "billNo",
  },
  {
    title: "Section",
    dataIndex: "sectionName",
  },
 {
  title: "Customer Name",
  dataIndex: "customer.name",
  render: (_, record) => record?.customer?.name || "",
},
  {
    title: "Amount",
    dataIndex: "amount",
   render: (val) => Number(val || 0).toFixed(2),
  },
];
 

   const section = sectionList?.map((e) => ({
     value: e.guid,
     label: e.name,
   }));
 
   const handletogglehead = () => {
     dispatch(setheadertoggle(!togglehead));
   };
   const handleFromDateChange = (date) => {
     console.log(date, "from date");
     setFromDate(date);
 
     setToDate(null); // reset to date when from date changes
   };
   const handleToDateChange = (date) => {
     setToDate(date);
   };
 
const modifiedList = salesData?.filter((obj) => {
  const searchMatch =
    obj.billNo?.toLowerCase().includes(searchText.toLowerCase()) ||
    obj.sectionName?.toLowerCase().includes(searchText.toLowerCase()) ||
    obj.customer?.name?.toLowerCase().includes(searchText.toLowerCase());

      const customerMatch =
    !customer || obj?.customer?.name === customer?.label;

  return searchMatch&&customerMatch;
});

const modifiedallList = allData?.filter((obj) => {

   const searchMatch =
    obj.billNo?.toLowerCase().includes(searchText.toLowerCase()) ||
    obj.sectionName?.toLowerCase().includes(searchText.toLowerCase()) ||
    obj.customer?.name?.toLowerCase().includes(searchText.toLowerCase());

      const customerMatch =
    !customer || obj?.customer?.name === customer?.label;

  return searchMatch&& customerMatch;
});
 //       useEffect(() => {
 //   setCurrentPage(1);
 // }, [modifiedallList]);
   const getActiveTabData = () => {
     let fieldMapping = {};
 
     // Function to create the field mapping between column titles and dataIndex values
     const createfieldMapping = (columns) => {
       const mappings = {};
       columns.forEach((col) => {
         mappings[col.title] = col.dataIndex; // Map title to dataIndex
       });
       return mappings;
     };
 
     // Generate the field mapping for the current columns
     fieldMapping = createfieldMapping(columns);
 
     // Return the filtered data, columns, and field mapping
     return { data: modifiedallList, columns: columns, fieldMapping,Rname:"Customer Credit Report",fromDate,toDate};
     };
 
 


   const handleReset = () => {
     setFromDate((prev) => dayjs());
     setToDate((prev) => dayjs());
     setSearchText("");
 
     // handlegetsalesfullReport();
     // handlegetsalesReport(currentPage, pageSize);
   };
 
const totalAmount = (modifiedallList || []).reduce(
  (sum, record) => sum + (record.amount || 0),
  0
);
const footerTotals = {
  amount: Number(totalAmount || 0).toFixed(2),
};


   const handleRefresh = () => {
      handlegetsalesReport(currentPage, pageSize);
     handlegetsalesfullReport(); 
   };
   return (
     <div>
       <LoadingUtils loading={loading} />
       <div className="page-wrapper">
         <div className="content">
           <div className="page-header transfer">
             <div className="add-item d-flex">
               <div className="page-title">
                 <h4>Customer Credit Report</h4>
               </div>
             </div>
 
             <ul className="table-top-head">
               <li>
                 <OverlayTrigger placement="top" overlay={renderTooltip("PDF")}>
                   <button
                     onClick={() =>
                       exportreportPDF(getActiveTabData,footerTotals,companyInfolist)
                     }
                     disabled={loading}
                     className="btn btn-link bg-white rounded-lg border border-silver"
                   >
                     <ImageWithBasePath
                       src="assets/img/icons/pdf.svg"
                       alt="img"
                     />
                   </button>
                 </OverlayTrigger>
               </li>
               <li>
                 <OverlayTrigger
                   placement="top"
                   overlay={renderTooltip("Excel")}
                 >
                   <button
                     onClick={() =>
                       exportreportExcel(getActiveTabData,footerTotals,companyInfolist)
                     }
                     disabled={loading}
                     className="btn btn-link bg-white rounded-lg border border-silver"
                   >
                     <ImageWithBasePath
                       src="assets/img/icons/excel.svg"
                       alt="excel-icon"
                     />
                   </button>
                 </OverlayTrigger>
               </li>
               <li>
                 <OverlayTrigger
                   placement="top"
                   overlay={renderTooltip("Print")}
                 >
                   <button
                     onClick={() =>
                       printreportReport(getActiveTabData,footerTotals,companyInfolist)
                     }
                     disabled={loading}
                     className="btn btn-link bg-white rounded-lg border border-silver"
                   >
                     <i data-feather="printer" className="feather-printer" />
                   </button>
                 </OverlayTrigger>
               </li>
               <li>
                 <OverlayTrigger
                   placement="top"
                   overlay={() => renderTooltip("Refresh")}
                 >
                   <Link onClick={handleRefresh}>
                     <RotateCcw />
                   </Link>
                 </OverlayTrigger>
               </li>
               <li>
                 <OverlayTrigger
                   placement="top"
                   overlay={renderTooltip("Collapse")}
                 >
                   <Link
                     data-bs-toggle="tooltip"
                     data-bs-placement="top"
                     id="collapse-header"
                     className={togglehead ? "active" : ""}
                     onClick={handletogglehead}
                   >
                     <ChevronUp />
                   </Link>
                 </OverlayTrigger>
               </li>
             </ul>
           </div>
 
           <div className="card table-list-card">
             <div className="card-body">
               <div className="table-top">
                 <div className="search-set mt-2">
                   <div className="search-input">
                     <Link to="#" className="btn btn-searchset">
                       <svg
                         xmlns="http://www.w3.org/2000/svg"
                         width={24}
                         height={24}
                         viewBox="0 0 24 24"
                         fill="none"
                         stroke="currentColor"
                         strokeWidth={2}
                         strokeLinecap="round"
                         strokeLinejoin="round"
                         className="feather feather-search"
                       >
                         <circle cx={11} cy={11} r={8} />
                         <line x1={21} y1={21} x2="16.65" y2="16.65" />
                       </svg>
                     </Link>
                     <div
                       id="DataTables_Table_0_filter"
                       className="dataTables_filter "
                     >
                       <label>
                         {" "}
                         <input
                           type="search"
                           className="form-control form-control-sm"
                           placeholder="Search"
                           aria-controls="DataTables_Table_0"
                           value={searchText}
                           onChange={handleSearch}
                         />
                       </label>
                     </div>
                   </div>
                 </div>
                 <div className="row">
                   <div className="col-md-4">
                     <div className="input-blocks">
                       <label htmlFor="from-date">From Date</label>
                       <div className="input-groupicon calender-input">
                         <Calendar className="info-img" />
                         <DatePicker
                           className="datetimepicker"
                           id="from-date"
                           placeholderText="From Date"
                           // selected={fromDate}
                           value={fromDate}
                           onChange={handleFromDateChange}
                           startDate={fromDate}
                           selectsStart
                           // dateFormat="dd/MM/yyyy"
                         />
                       </div>
                     </div>
                   </div>
                   <div className="col-md-4">
                     <div className="input-blocks">
                       <label htmlFor="to-date">To Date</label>
                       <div className="input-groupicon calender-input">
                         <Calendar className="info-img" />
                         <DatePicker
                           id="to-date"
                           placeholderText="To Date"
                           // selected={toDate}
                           value={toDate}
                           onChange={handleToDateChange}
                           minDate={fromDate}
                           startDate={fromDate}
                           selectsEnd
                           disabled={!fromDate} // disable until from date is selected
                           // dateFormat="dd/MM/yyyy"
                           // className='form-control'
                         />
                       </div>
                     </div>
                   </div>
                   <div className="col-md-4 ">
  <div className="input-blocks mr-2">
    <label>Customer</label>
    <Select
      className="img-select"
      options={formatedcustomerList}
      value={customer}
      onChange={setCustomer}
      isClearable
      classNamePrefix="react-select"
      placeholder="Customer"
    />
  </div>
</div>
                 </div>
                 <div className="d-flex justify-content-end mt-4">
                   <div className="input-blocks me-2">
                     <button
                       className="btn btn-filters rounded-2 h-70"
                       onClick={() => {
                         setCurrentPage(1);
                         setPageSize(20);
                         handlegetsalesfullReport();
                         handlegetsalesReport(currentPage, pageSize);
                       }}
                       disabled={!fromDate || !toDate}
                     >
                       <i data-feather="search" className="feather-search" />{" "}
                       Search
                     </button>
                   </div>
                   <div className="input-blocks">
                     <button
                       className="btn btn-reset rounded-2 h-70"
                       onClick={handleReset}
                     >
                       <i
                         data-feather="refresh-cw"
                         className="feather-refresh-cw"
                       />{" "}
                       Reset
                     </button>
                   </div>
                 </div>
 
             
 
             
               </div>
 
               {/* /Filter */}
             
                 <div className="table-responsive product-list">
                   {/* <Table
                     columns={selectedColumns}
                     dataSource={salesData}
                     ref={tableRef}
                     id="table-to-export"
                     className="table datanew dataTable no-footer custom-table"
                     pagination={{
                       showTotal: (total, range) =>
                         `${range[0]}-${range[1]} of ${totalcount} items`,
                       current: currentPage,
                       pageSize: pageSize,
                       total: totalcount, // Total records count
                       onChange: (page, size) => {
                         setCurrentPage(page);
                         setPageSize(size);
                         handlegetsalesReport(page, size);
                       },
                       showSizeChanger: true, // To enable page size selection dropdown
                       pageSizeOptions: ["10", "20", "50", "100"], // Different page size options
                     }}
                     summary={() => (
                       <Table.Summary.Row>
                         {selectedColumns?.map((col) => (
                           <Table.Summary.Cell key={col.dataIndex}>
                             <b>{footerTotals[col.dataIndex] || ""}</b>
                           </Table.Summary.Cell>
                         ))}
                       </Table.Summary.Row>
                     )}
                   /> */}
 
                   <Table
   columns={columns}
   dataSource={modifiedallList}
   ref={tableRef}
   id="table-to-export"
   className="table datanew dataTable no-footer custom-table"
   pagination={{
     showTotal: (total, range) =>
       `${range[0]}-${range[1]} of ${modifiedallList?.length} items`,
     current: currentPage,
     pageSize: pageSize,
     total: modifiedallList?.length,
     onChange: (page, size) => {
       setCurrentPage(page);
       setPageSize(size);
     },
     showSizeChanger: true,
     pageSizeOptions: ["10", "20", "50", "100"],
   }}
summary={() => (
  <Table.Summary.Row>
    <Table.Summary.Cell colSpan={4}>
      <b>Total</b>
    </Table.Summary.Cell>
    <Table.Summary.Cell>
      <b>{footerTotals.amount}</b>
    </Table.Summary.Cell>
  </Table.Summary.Row>
)}
 />
 
                 </div>
              
             </div>
           </div>
           {/* /product list */}
         </div>
       </div>
     </div>
   );
};

export default CustomerCredit;